<template>
    <RequiredDocumentsContainer>
        <DocumentsHeader>
            <DocumentsTitle>{{ documents.title }}</DocumentsTitle>
            <DocumentsDescription>{{ documents.description }}</DocumentsDescription>
        </DocumentsHeader>

        <DocumentsSection>
            <DocumentItem v-for="doc in documents.required" :key="doc.name" class="required">
                <DocumentContent>
                    <DocumentName>{{ doc.name }}</DocumentName>
                    <DocumentDescription>{{ doc.description }}</DocumentDescription>
                </DocumentContent>
            </DocumentItem>
        </DocumentsSection>

        <DocumentsTips>
            <TipsTitle>💡 청구 시 주의사항</TipsTitle>
            <TipItem v-for="tip in documents.tips" :key="tip">
                <TipBullet></TipBullet>
                <span>{{ tip }}</span>
            </TipItem>
        </DocumentsTips>
    </RequiredDocumentsContainer>
</template>

<script>
import * as RequiredDocumentsModalCss from '@/assets/styles/claim/modal/RequiredDocumentsModalCss.js';

export default {
    name: 'RequiredDocumentsModal',

    components: {
        ...RequiredDocumentsModalCss
    },

    props: {
        claimType: {
            type: String,
            required: true
        }
    },

    computed: {
        documents() {
            const documentsMap = {
                'oxygen': {
                    title: '산소발생기 청구 서류',
                    description: '산소발생기 청구에 필요한 필수 서류들을 확인하세요.',
                    required: [
                        { name: '건강보험 산소치료 급여대상자 등록 신청서', description: '환자등록시 필요한 서류입니다.', required: true },
                        { name: '산소치료 처방전', description: '처방전에 산소치료의 구체적인 정보가 명시되어야 합니다.', required: true },
                        { name: '신분증', description: '신분증 사본, 복사본 가능합니다.', required: true },
                        { name: '현금영수증', description: '한큐의료기에서 청구 진행시 자동 발행 후 청구에 등록됩니다.', required: true },
                        { name: '전자세금계산서', description: '한큐의료기에서 청구 진행시 자동 발행 후 청구에 등록됩니다.', required: true }
                    ],
                    tips: [
                        '산소치료 처방기간은 1년 이내입니다.',
                        '산소치료 처방전에는 산소치료의 구체적인 정보가 명시되어야 합니다.',
                        '각 서류에 정보와 서명 등이 명시되었는지 확인해주세요.'
                    ]
                },
                'diabetes': {
                    title: '당뇨소모성재료 청구 서류',
                    description: '당뇨소모성재료 청구에 필요한 필수 서류들을 확인하세요.',
                    required: [
                        { name: '건강보험 당뇨병환자 등록 신청서', description: '환자등록시 필요한 서류입니다.', required: true },
                        { name: '당뇨병환자 소모성 재료 처방전', description: '', required: true },
                        { name: '신분증', description: '신분증 사본, 복사본 가능합니다.', required: true },
                        { name: '현금영수증', description: '한큐의료기에서 청구 진행시 자동 발행 후 청구에 등록됩니다.', required: true },
                        { name: '전자세금계산서', description: '한큐의료기에서 청구 진행시 자동 발행 후 청구에 등록됩니다.', required: true },
                        { name: '거래명세서', description: '', required: true }
                    ],
                    tips: [
                        '처방전에는 당뇨병환자 소모성 재료의 구체적인 정보가 명시되어야 합니다.',
                        '거래명세서에는 위 파일을 다운받아 활용하실 수 있습니다.',
                        '각 서류에 정보와 서명 등이 명시되었는지 확인해주세요.'
                    ]
                },
                'assistance': {
                    title: '보조기기 청구 서류',
                    description: '보조기기 청구에 필요한 필수 서류들을 확인하세요.',
                    required: [
                        { name: '보조기기 처방전', description: '', required: true },
                        { name: '신분증', description: '신분증 사본, 복사본, 복지카드 가능합니다.', required: true },
                        { name: '바코드 사진', description: '보조기기에 부착된 바코드 사진을 촬영해주세요.', required: true },
                        { name: '현금영수증', description: '한큐의료기에서 청구 진행시 자동 발행 후 청구에 등록됩니다.', required: true },
                        { name: '전자세금계산서', description: '한큐의료기에서 청구 진행시 자동 발행 후 청구에 등록됩니다.', required: true },
                        { name: '보조기기 급여 지급청구서', description: '', required: true },
                        { name: '보조기기 급여 지급청구 위임장', description: '', required: true },
                    ],
                    tips: [
                        '보조기기 급여 지급청구서와 위임장은 위 파일을 다운받아 활용하실 수 있습니다.',
                        '욕창예방매트리스와 방석의 경우 MBI, 다리맨손근력검사 결과 서류가 필요합니다.',
                        '보청기의 경우 검수확인서, 표준구매계약서, 검사결과 서류가 필요합니다.',
                        '각 서류에 정보와 서명 등이 명시되었는지 확인해주세요.'
                    ]
                }
            };

            return documentsMap[this.claimType] || documentsMap['oxygen'];
        }
    }
};
</script>